import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HotRanking() {
  const displayMovies = hotMovies.slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">
              大家都在看的热门影视
            </p>
          </div>
          <Link
            to="/category/movie"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {displayMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl mb-3">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ aspectRatio: '2/3' }}
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold text-background-50 ${
                    index < 3 ? 'bg-primary-500' : 'bg-foreground-700/60'
                  }`}>
                    {index + 1}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-xs text-background-50 bg-primary-500/90 px-2 py-1 rounded-md whitespace-nowrap">
                    {movie.updateEpisode}
                  </span>
                </div>
                {movie.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md whitespace-nowrap">
                      NEW
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  {movie.rating}
                </span>
                <span>{movie.category}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}